import React, { useCallback, useMemo } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import InvoiceDocumentsList from './InvoiceDocumentsList';
import { subscribeToClientPreinvoices } from '../utils/preinvoiceUtils';
import { subscribeToClientInvoices } from '../utils/invoiceUtils';

export default function ClientSaskaitosPage() {
  const { currentUser } = useAuth();
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const clientEmail = currentUser?.email?.trim().toLowerCase() || '';
  const clientUid = currentUser?.uid || '';

  const preinvoiceSubscribe = useCallback(
    (year, callback) => subscribeToClientPreinvoices(year, clientEmail, clientUid, callback),
    [clientEmail, clientUid]
  );

  const invoiceSubscribe = useCallback(
    (year, callback) => subscribeToClientInvoices(year, clientEmail, clientUid, callback),
    [clientEmail, clientUid]
  );

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', py: 4 }}>
      <Container maxWidth="md">
        <Typography variant="h4" sx={{ mb: 1, fontWeight: 700, letterSpacing: '-0.02em' }}>
          Sąskaitos
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Čia matote jums priskirtas išankstines sąskaitas ir sąskaitas faktūras.
        </Typography>

        <InvoiceDocumentsList
          enabled={Boolean(clientEmail || clientUid)}
          currentYear={currentYear}
          readOnly
          headerTitle={`Mano sąskaitos (${currentYear})`}
          emptyHint="Jums dar nepriskirta jokių sąskaitų."
          preinvoiceSubscribe={preinvoiceSubscribe}
          invoiceSubscribe={invoiceSubscribe}
        />
      </Container>
    </Box>
  );
}
